export default {
  app: {
    name: '醫影IM'
  },
  init: {
    loading: '正在初始化...',
    connecting: '連接服務中...',
    loginIM: '登入通訊服務...',
    subtitle: '即時通訊',
    footer: '安全加密的即時通訊服務',
    error: {
      noToken: '鏈接已失效，請重新獲取',
      sigFail: '取得簽章失敗，請重試',
      loginFail: '登入失敗：{msg}',
      retry: '重試',
      hint: '請檢查網路連線後重試'
    }
  },
  permission: {
    title: '檢測到權限未開啟',
    desc: '為保證正常通話，請點擊下方按鈕，然後在瀏覽器彈出權限提示時選擇"允許"',
    openBtn: '去開啟權限',
    skipBtn: '暫不需要',
    deniedTitle: '請開啟麥克風/攝像頭權限',
    deniedDesc: '請在瀏覽器設定中開啟權限，然後點擊下方按鈕重試',
    deniedStep1: '方法一（推薦）：點擊瀏覽器網址列左側的鎖定圖示 🔒',
    deniedStep2: '→ 權限 → 麥克風/攝像頭 → 設為"允許"',
    deniedStep3: '方法二：開啟瀏覽器設定 → 隱私與安全性 → 找到並允許麥克風/攝像頭',
    deniedBtn: '重試'
  },
  agreement: {
    title: '使用者協議',
    loading: '協議載入中...',
    loadFail: '協議載入失敗，請重試',
    retry: '重試',
    agree: '我同意',
    reject: '我不同意',
    scrollHint: '請閱讀完整協議後同意',
    rejectedTitle: '您已拒絕該協議',
    rejectedDesc: '請關閉當前頁面'
  },
  conversation: {
    title: '訊息',
    empty: '暫無對話',
    online: '線上',
    offline: '離線',
    connecting: '連接中',
    user: '用戶',
    lastMsg: {
      image: '[圖片]',
      audio: '[語音]',
      video: '[影片]',
      file: '[檔案]',
      face: '[表情]',
      custom: '[訊息]',
      calling: '[通話]',
      recall: '訊息已撤銷'
    }
  },
  chat: {
    placeholder: '說點什麼...',
    send: '發送',
    recall: '撤銷訊息',
    recallSuccess: '訊息已撤銷',
    recallFail: '撤銷失敗，超出時間限制',
    copyText: '複製',
    deleteMsg: '刪除',
    loadMore: '載入更多',
    noMore: '沒有更多訊息了',
    inputPlaceholder: '輸入訊息...',
    calling: '[視訊通話]',
    callEnd: '通話結束',
    callDuration: '通話時長 {duration}',
    callConnected: '通話已接通',
    callMissed: '未接聽',
    callCancelled: '已掛斷',
    callRejected: '已拒絕',
    imagePreview: '圖片預覽',
    downloadFile: '下載檔案',
    voiceSeconds: '{sec}秒',
    customLink: '查看詳情',
    survey: '評分',
    holdToSpeak: '長按說話',
    releaseToSend: '放開發送',
    releaseToCancel: '上滑取消',
    durationSecond: '{count}秒'
  },
  call: {
    incomingVideo: '視訊通話',
    incomingAudio: '語音通話',
    calling: '正在呼叫...',
    callingUser: '正在呼叫 {name}...',
    incomingFrom: '{name} 來電了',
    incomingVideoFrom: '{name} 發起視訊通話',
    incomingAudioFrom: '{name} 發起語音通話',
    connecting: '正在接通...',
    accept: '接聽',
    reject: '拒絕',
    hangup: '掛斷',
    mute: '靜音',
    unmute: '取消靜音',
    camera: '鏡頭',
    switchCamera: '翻轉',
    speaker: '喇叭',
    timeout: '對方無回應',
    busy: '對方正在通話中',
    callRejected: '對方已拒絕',
    ended: '通話已結束',
    duration: '通話時長 {duration}',
    failed: '通話失敗',
    permissionDenied: '請允許鏡頭和麥克風權限',
    networkError: '網路不穩定',
    videoCall: '[視訊通話]',
    audioCall: '[語音通話]'
  },
  common: {
    confirm: '確認',
    cancel: '取消',
    back: '返回',
    loading: '載入中...',
    networkError: '網路錯誤，請檢查連線',
    unknownError: '發生未知錯誤',
    today: '今天',
    yesterday: '昨天'
  },
  error: {
    expired: '連結已過期',
    kicked: '您已在其他設備登入',
    noauth: '請從正確入口進入',
    somethingWrong: '出了點問題',
    expiredDesc: '請重新獲取存取連結',
    kickedDesc: '您的帳號已在其他設備登入，連線已中斷',
    noauthDesc: 'URL 中缺少必要的 token，請重新掃碼或獲取連結'
  },
  message: {
    unknownFile: '未知檔案',
    unsupportedMsg: '[不支援的訊息類型]',
    viewDetail: '查看詳情',
    sessionCreated: '已建立連線',
    systemMsg: '[系統訊息]',
    sendFailed: '傳送失敗，請重試',
    imageSendFailed: '圖片傳送失敗，請重試',
    roomInvalid: '房間資訊無效'
  }
}